import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import MyListTable from "./myListTable";
import StatsItem from "./statsItem";

const InnCodeTab = (props: any) => {
  const { selectedListId } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const { myListDetails } = useAppSelector((state) => state.sme);

  return (
    <>
      <Box
        sx={{
          borderBottom: `1px solid ${tokens.Border.General.Tertiary}`,
          padding: "20px 24px 32px 24px",
          backgroundColor: tokens.Background.General.Primary
        }}
      >
        {isMobileScreen && (
          <Typography
            variant="body2"
            showBold
            color={tokens.Text.General.Secondary}
            sx={{
              marginTop: "24px",
              marginBottom: "4px",
              paddingX: "12px"
            }}
          >
            Plans
          </Typography>
        )}
        <Grid
          container
          sx={{
            backgroundColor: tokens.Background.General.Tertiary,
            paddingY: "12px",
            borderRadius: "12px",
            width: "100%"
          }}
        >
          {isMobileScreen ? (
            <>
              <StatsItem title="Inncodes" data={myListDetails.innCodeGroupMappingCount || 0} />
              <StatsItem title="Plan Assignments" data={myListDetails.assignedPlanCount || 0} />
            </>
          ) : (
            <>
              <StatsItem title="Inncodes" data={myListDetails.innCodeGroupMappingCount || 0} />
              <StatsItem title="Plan Assignments" data={myListDetails.assignedPlanCount || 0} />
              <StatsItem title="High Engagement" data={myListDetails.highEngagementCount || 0} />
              <StatsItem title="Medium Engagement" data={myListDetails.mediumEngagementCount || 0} />
              <StatsItem title="Low Engagement" data={myListDetails.lowEngagementCount || 0} />
            </>
          )}
        </Grid>

        {isMobileScreen && (
          <>
            <Typography
              variant="body2"
              showBold
              color={tokens.Text.General.Secondary}
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                paddingX: "12px"
              }}
            >
              Engagement
            </Typography>
            <Grid
              container
              alignItems="center"
              sx={{
                backgroundColor: tokens.Background.General.Tertiary,
                paddingY: "12px",
                borderRadius: "12px"
              }}
            >
              <StatsItem title="High" data={myListDetails.highEngagementCount || 0} />
              <StatsItem title="Medium" data={myListDetails.mediumEngagementCount || 0} />
              <StatsItem title="Low" data={myListDetails.lowEngagementCount || 0} />
            </Grid>
          </>
        )}
      </Box>

      <MyListTable listId={selectedListId} />
    </>
  );
};

export default InnCodeTab;
